import { Channel as ChannelType } from "stream-chat";

export function getGroupChatName(channel: ChannelType): string {
  const data = channel.data as { name?: string };
  const members = Object.values(channel.state.members);

  if (data?.name) {
    return `${data.name} (${members.length})`;
  } else {
    return `Group Chat (${members.length})`;
  }
}

export function getOtherMemberName(
  channel: ChannelType,
  currentUserId: string,
): string {
  const members = channel.state.members;

  const otherMember = Object.values(members).find(
    (member: { user_id?: string }) => member.user_id !== currentUserId,
  );

  return otherMember?.user?.name || otherMember?.user_id || "No user";
}

export function getChannelMembers(channel: ChannelType | null): string[] {
  if (channel !== null) {
    const members = Object.values(channel.state.members);
    const usernames = members.map(
      (member: { user?: { name?: string } }) =>
        member.user?.name || "No username",
    );
    return usernames;
  }
  return [];
}

export function getChannelPartner(channel: ChannelType | null): string | null {
  if (channel !== null) {
    const currentUserId = channel._client.user?.id;
    if (currentUserId !== undefined) {
      const members = channel.state.members;
      if (Object.values(members).length > 2) {
        return getGroupChatName(channel);
      } else {
        return getOtherMemberName(channel, currentUserId);
      }
    }
  }
  return null;
}
